export const iconFontAwesomeClothingFashionShirt = (
	<i className="fa-solid fa-shirt"></i>
);
